export * from './gs-icon-sprites.component';